import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changeMinCeilingHeight } from '../../../../../../state/advanced/ceiling_height';

import { ICeilingHeightProps, CeilingHeight as CeilingHeightComponent } from './ceilingHeight';

type TCeilingHeightStateProps = Pick<ICeilingHeightProps, 'value'>;
type TCeilingHeightDispatchProps = Pick<ICeilingHeightProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TCeilingHeightStateProps {
  return {
    value:
      (state.filters.jsonQuery.ceiling_height &&
        state.filters.jsonQuery.ceiling_height.value &&
        state.filters.jsonQuery.ceiling_height.value.gte) ||
      0,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TCeilingHeightDispatchProps {
  return {
    onChange: (value: number) => {
      dispatch(changeMinCeilingHeight(value));
    },
  };
}

export const CeilingHeight = connect(mapStateToProps, mapDispatchToProps)(CeilingHeightComponent);
